// extracted by mini-css-extract-plugin
module.exports = {"Grid":"LogoGrid_Grid__3euW6","GridItem":"LogoGrid_GridItem__1oH_2","ImageHolder":"LogoGrid_ImageHolder__3VHw-"};